<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<mat-expansion-panel
  [id]="id + '-panel'"
  (opened)="onOpened($event)"
  (closed)="onClosed($event)"
  [expanded]="expanded"
  [disabled]="true"
  hideToggle
>
  <!-- Header -->
  <mat-expansion-panel-header
    [collapsedHeight]="'62px'"
    [expandedHeight]="'62px'"
    class="rel cp"
    (click)="onExpandClick($event)"
  >
    <mat-panel-title>
      <div class="form-panel">
        <rx-icon [id]="'icon-' + id" *ngIf="icon" [name]="icon" class="folder"></rx-icon>
        <div class="content-text">
          <div>
            <div [id]="'top-' + id" class="top">{{ title }}</div>
            <div [id]="'bottom-' + id" class="bottom">{{ description }}</div>
            <div *ngIf="secondLine">secondline</div>
          </div>
        </div>
      </div>
    </mat-panel-title>
    <mat-action-row *ngIf="!busy">
      <div class="flex flex-row mr20" [rxRoleGuard]="rejectedRoles">
        <rx-icon
          [id]="'icon-drag-' + id"
          *ngIf="showDragHandle"
          name="icon-drag"
          class="rel z1"
          (mouseenter)="onEnableDrag(true)"
          (mouseleave)="onEnableDrag(false)"
          cdkDragHandle
          (click)="onDragIconclick($event)"
        ></rx-icon>
        <rx-icon
          [id]="'icon-ellipse-' + id"
          *ngIf="showMenuHandle"
          name="icon-ellipses"
          class="rel z1"
          (click)="onMenuClicked($event)"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>
      </div>
      <rx-icon
        [id]="'icon-expand-' + id"
        *ngIf="showExpandHandle"
        name="icon-expand"
        size="12"
        [ngClass]="{ rotate180: expanded }"
      ></rx-icon>
    </mat-action-row>
    <!-- Spinner --><!-- TODO: Improve this. Convert spinner to directive. -->
    <div class="busy-spinner" *ngIf="busy">
      <rx-icon name="icon-spinner"></rx-icon>
    </div>
  </mat-expansion-panel-header>

  <!-- Content -->
  <ng-content></ng-content>
</mat-expansion-panel>
